<template>
  <el-dialog
    :title="$t('lang.warning')"
    :visible.sync="eventAdjustmentData.show"
    :modal-append-to-body="true"
    :append-to-body="true"
    width="600px"
    class="eventAdjustment">
    <div class="content">
      <div class="header" v-html="$t('lang.eventAdjustTips',{title:eventAdjustmentData.currentEventTitle,time:changeTime (eventAdjustmentData.takeNextTime),endTime:changeTime(eventAdjustmentData.currentEventEndTime),difference:getDuration(eventAdjustmentData.duration)})"></div>
      <div class="tips">{{$t('lang.eventAdjust')}}</div>
      <div v-for="(item,index) in eventAdjustmentData.followOnEventVoList" :key="index" class="eventAdjustmentContent">
        <div v-if="item.type==1">
          <span class="title">{{ item.title }}</span>
          <span class="NewStartTime"> {{$t('lang.NewStartTime')}} </span>
          <span class="time">{{ changeTime(item.startTime) }} - {{$t('lang.NewDuration')}} {{ getDuration(item.newDuration) }}</span>
          ({{$t('lang.PreviousDuration')}} {{ getDuration(item.previousDuration) }})
        </div>
        <div v-if="item.type==2"><span class="title">{{ item.title }}</span> {{ item.multipleModelType==1?'F/O':changeTime(item.startTime) }}  - {{ changeTime(item.endTime) }} <span class="time">{{$t('lang.Removed')}}</span></div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="success" @click="eventAdjustmentData.show = false">{{$t('lang.GotIt')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Outil from '@/assets/js/utils.js'
export default {
  props: {
    eventAdjustmentData: {
      type: Object,
      default: () => {
        return {
          show: false
        }
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    // 持续时间
    getDuration (time) {
      return Outil.getDuration(time)
    },
    // 时间转换
    changeTime (time) {
      return Outil.TransitionCurrentTime(new Date(time))
    }
  }
}
</script>

<style lang="less" scoped>
.eventAdjustment{
  ::v-deep .el-dialog{
    background: #252525;
    border-radius: 6px 6px 6px 6px;
    // padding: 0;
    .el-dialog__header{
      // padding: 16px 24px;
      line-height: 50px;
      height: 50px;
      .el-dialog__title{
        color: #DBDBDB;
        font-size: 16px;
        font-weight: 700;
      }
    }
    .el-dialog__body{
      padding: 10px 20px;
      .header{
        color: #666666;
        font-size: 14px;
        padding-bottom: 10px;
      }
      .tips{
        color: #DBDBDB;
        font-size: 14px;
        padding-bottom: 10px;
      }
      .eventAdjustmentContent{
        color: #666666;
        padding-right: 10px;
          .title{
            color: #DBDBDB;
          }
          .time{
            color: #E56464;
          }
        }
    }
    .el-dialog__footer{
      padding: 24px 20px;
      .el-button--success{
        width: 71px;
        height: 32px;
        line-height: 0;
        padding: 0;
        background: #33AB4F;
        color: #FFFFFF;
        border: 1px solid #33AB4F;
      }
    }
  }

}
</style>
